import axios from 'axios';

const graphqlApi = axios.create({
    method:'post',
    baseURL: `${process.env.REACT_APP_API_URL}/graphql`,
})

export default graphqlApi;